import React from "react";
import { cn } from "@/lib/utils";
import { WORKFLOW, AGENDA, PUBLICATION, CONSIDERATION, DECISION, VISIBILITY } from "@/lib/insightsApi";

function Badge({ label, cls, testid }) {
  return (
    <span data-testid={testid} className={cn(
      "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap",
      cls || "bg-slate-100 text-slate-600 border-slate-300")}>
      {label}
    </span>
  );
}

export function WorkflowBadge({ status }) {
  const s = WORKFLOW[status] || { label: status };
  return <Badge label={s.label} cls={s.cls} testid="insight-workflow-badge" />;
}

export function VisibilityBadge({ visibility }) {
  const v = VISIBILITY[visibility] || { label: visibility };
  return <Badge label={v.label} cls={v.cls} testid="insight-visibility-badge" />;
}

// A labelled, visually-separated chip for a secondary status domain.
export function DomainChip({ domainLabel, value, map, testid }) {
  return (
    <div className="flex flex-col gap-1" data-testid={testid}>
      <span className="text-[10px] font-semibold uppercase tracking-wider text-slate-400">{domainLabel}</span>
      <span className="inline-flex items-center rounded-md border border-brand-line bg-brand-bg px-2 py-0.5 text-xs font-medium text-brand-ink">
        {(map && map[value]) || value || "—"}
      </span>
    </div>
  );
}

// The full independent-status-domain strip. Each domain is separate — never merged.
export function StatusDomainStrip({ insight }) {
  return (
    <div className="flex flex-wrap gap-x-6 gap-y-3" data-testid="insight-status-domains">
      <DomainChip domainLabel="Agenda" value={insight.agenda_status} map={AGENDA} testid="domain-agenda" />
      <DomainChip domainLabel="Publication" value={insight.publication_status} map={PUBLICATION} testid="domain-publication" />
      <DomainChip domainLabel="Consideration" value={insight.consideration_status} map={CONSIDERATION} testid="domain-consideration" />
      <DomainChip domainLabel="Decision" value={insight.decision_status} map={DECISION} testid="domain-decision" />
    </div>
  );
}
